jQuery(document).ready(function ($) {
  if (document.body.classList.contains("block-editor-page")) return;

  const onScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };

    document.addEventListener("longevity:scroll-ready", runOnce, {
      once: true,
    });
    setTimeout(runOnce, 0);
  };

  if (typeof wp !== "undefined" && wp.domReady) {
    wp.domReady(() => onScrollReady(initFeatureGrid));
  } else {
    onScrollReady(initFeatureGrid);
  }

  function initFeatureGrid() {
    const blocks = document.querySelectorAll(".js-feature-grid");
    if (!blocks.length) return;

    if (typeof window.gsap === "undefined") return;
    const gsap = window.gsap;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (_) {}
    }

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    blocks.forEach((block) => {
      if (block.dataset.fgInit === "1") return;
      block.dataset.fgInit = "1";

      const items = block.querySelectorAll(".js-fg-item");
      const cards = block.querySelectorAll(".js-fg-card");

      if (!items.length) return;

      if (reduceMotion) {
        gsap.set(items, { autoAlpha: 1, y: 0, clearProps: "transform" });
        return;
      }

      gsap.set(items, { autoAlpha: 0, y: 18 });

      const tl = gsap.timeline({
        defaults: { ease: "power3.out", duration: 0.9 },
        ...(ScrollTrigger
          ? { scrollTrigger: { trigger: block, start: "top 75%", once: true } }
          : {}),
      });

      tl.to(
        items,
        { autoAlpha: 1, y: 0, stagger: 0.08, clearProps: "transform" },
        0,
      );

      cards.forEach((card) => {
        card.addEventListener("mouseenter", () => {
          gsap.to(card, { y: -2, duration: 0.2, ease: "power2.out" });
        });
        card.addEventListener("mouseleave", () => {
          gsap.to(card, { y: 0, duration: 0.2, ease: "power2.out" });
        });
      });
    });
  }
});
